import { createContext, useState, useContext, ReactNode } from 'react';

export interface CoursePreviewData {
  id?: number | string;
  fullname?: string | null;
  summary?: string | null;
  coverImageUrl?: string | null;
  language?: string | null;
  category_id?: string | null;
  modules?: { id: string; title: string; type?: string }[];
  certificate?: { id?: number | string; name?: string } | null;
  skills?: { id: number | string; name: string }[];
  generalSettings?: {
    category_id?: string;
    language?: string;
    linked_skills?: string[];
    start_date?: string;
    end_date?: string;
  };
}

interface CoursePreviewContextType {
  coursePreviewData: CoursePreviewData | null;
  setCoursePreviewData: (data: CoursePreviewData | null) => void;
}

const CoursePreviewContext = createContext<CoursePreviewContextType | undefined>(undefined);

export const CoursePreviewProvider = ({ children }: { children: ReactNode }) => {
  const [coursePreviewData, setCoursePreviewData] = useState<CoursePreviewData | null>(null);

  return (
    <CoursePreviewContext.Provider value={{ coursePreviewData, setCoursePreviewData }}>
      {children}
    </CoursePreviewContext.Provider>
  );
};

export const useCoursePreview = () => {
  const context = useContext(CoursePreviewContext);
  if (context === undefined) {
    throw new Error('useCoursePreview must be used within a CoursePreviewProvider');
  }
  return context;
};